<template>
  <div class="h-100">
    <div v-if="poster && poster.content" class="container-fluid text-center h-100">
      <div class="row">
        <div class="col text-left font-weight-bold" v-if="!isMobile()">{{ poster.presentation_code }}
          <span v-html="poster.title"></span>
        </div>
        <div class="col text-left smaller" v-else>{{ poster.presentation_code }} <span
            v-html="poster.title"></span></div>
      </div>
      <div class="row">
        <div class="col col-1 d-flex">
          <router-link :to="getBackUrl()" class="mr-auto my-auto">
            <button class="btn btn pl-0">
              <icon :icon="['fad', 'arrow-circle-left']"/>
              Back
            </button>
          </router-link>
        </div>
        <div class="col col-2 col-lg d-flex mx-auto">
          <button class="btn my-auto mx-auto" v-on:click="toggleFullscreen" title="Toggle fullscreen">
            <icon :icon="['fad', 'expand']"/>&nbsp;
            <span v-if="fullscreen === true">Close fullscreen</span>
            <span v-else="fullscreen">Fullscreen</span>
          </button>
        </div>
        <div class="col d-flex mx-auto" v-if="!isMobile()">
          <div class="mx-auto">
            <button class="btn" v-on:click="scale -= scale > 0.2 ? 0.1 : 0" title="Zoom out">
              <icon :icon="['fad', 'search-minus']" class="fa-1x"/>
            </button>
            <button class="btn" v-on:click="page = 1" v-if="page > 1" title="First page">
              <icon :icon="['fad', 'angle-double-left']" class="fa-2x"/>
            </button>
            <button class="btn disabled" disabled v-else>
              <icon :icon="['fad', 'angle-double-left']" class="fa-2x"/>
            </button>
            <button class="btn" v-on:click="page--" v-if="page > 1" title="Previous page">
              <icon :icon="['fad', 'angle-left']" class="fa-2x"/>
            </button>
            <button class="btn disabled" disabled v-else>
              <icon :icon="['fad', 'angle-left']" class="fa-2x"/>
            </button>
            <span>{{ page }} / {{ numPages }}</span>
            <button class="btn" v-on:click="page++" v-if="page < numPages" title="Next page">
              <icon :icon="['fad', 'angle-right']" class="fa-2x"/>
            </button>
            <button class="btn disabled" disabled v-else>
              <icon :icon="['fad', 'angle-right']" class="fa-2x"/>
            </button>
            <button class="btn" v-on:click="page = numPages" v-if="page < numPages" title="Last page">
              <icon :icon="['fad', 'angle-double-right']" class="fa-2x"/>
            </button>
            <button class="btn disabled" disabled v-else>
              <icon :icon="['fad', 'angle-double-right']" class="fa-2x"/>
            </button>
            <button class="btn" v-on:click="scale += scale < 2 ? 0.1 : 0" title="Zoom in">
              <icon :icon="['fad', 'search-plus']" class="fa-1x"/>
            </button>
          </div>
        </div>
        <div class="w-100 d-block d-sm-none" v-if="isMobile()"></div>
        <div class="col col-lg-2 d-flex my-auto" v-if="poster.content.audio"><span class="my-auto">Audio:&nbsp;</span>
          <audio controls>
            <source :src="getAudioUrl(poster.content.audio)">
            Your browser does not support the audio element.
          </audio>
        </div>
        <div class="w-100 d-block d-sm-none" v-if="isMobile()"></div>
        <div class="col">
          <router-link class="btn my-auto mx-auto" :to="'/viewer/abstract/' + poster.abstract_id"
                       title="Switch to abstract">
            <icon :icon="['fab', 'wpforms']"/>
            Abstract
          </router-link>
          <router-link class="btn my-auto mx-auto" :to="'/viewer/additional_paper/' + poster.abstract_id"
                       title="Switch to abstract" v-if="poster.content.additional_paper && $route.name ==='poster'">
            <icon :icon="['fab', 'wpforms']"/>
            Additional information
          </router-link>
          <router-link class="btn mx-auto my-auto" :to="'/viewer/' + poster.abstract_id" title="Switch to presentation"
                       v-if="poster.content.additional_paper && $route.name ==='additional_paper'">
            <icon :icon=" ['fad', 'file-pdf']"/>
            Presentation
          </router-link>

          <button class="btn my-auto mx-auto" v-if="poster.content.video != null" title="Switch to video"
                  v-on:click="showVideo(poster.abstract_id)">
            <icon :icon="['fad', 'video']" class="text-danger"/>
            Video
          </button>

          <a class="btn" :href="poster.docWebsite" target="_blank"
             v-if="poster.docWebsite != null" title="open website">
            <icon :icon="['fad', 'external-link-alt']"/>
            Website(external)
          </a>
        </div>
        <div class="col col-2 d-flex">
          <Rating :poster="poster.id" class="ml-auto my-auto"></Rating>
        </div>
        <div class="col-none col-lg col-lg-1">&nbsp;</div>
      </div>
      <div class="row">
        <div class="col border overflow-auto " v-if="poster && poster.content">
          <pdf :src="pdfdata" :key="page" :id="page" :page="page" :scale.sync="scale" style="max-height: 800px;">
          </pdf>
          <!--          <div id="carouselControls" class="carousel slide" data-ride="carousel">-->
          <!--            <div class="carousel-inner overflow-auto" >-->
          <!--              -->
          <!--              <Loader v-if="!show"></Loader>-->
          <!--            </div>-->
          <!--          </div>-->
          <a class="carousel-control-prev pointer-click" v-on:click="page--" v-if="page > 1" role="button">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next pointer-click" v-on:click="page++" v-if="page < numPages" role="button">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div class="col col-lg-2" v-if="!isMobile()">
          <Comment :poster_id="poster.id" v-if="poster"></Comment>
        </div>
      </div>
      <div class="row" v-if="isMobile()">
        <div class="col">
          <button class="btn" v-on:click="page = 1" v-if="page > 1" title="First page">
            <icon :icon="['fad', 'angle-double-left']"/>
          </button>
          <button class="btn disabled" disabled v-else>
            <icon :icon="['fad', 'angle-double-left']"/>
          </button>
          <button class="btn" v-on:click="page--" v-if="page > 1" title="Previous page">
            <icon :icon="['fad', 'angle-left']"/>
          </button>
          <button class="btn disabled" disabled v-else>
            <icon :icon="['fad', 'angle-left']"/>
          </button>
          <span>{{ page }} / {{ numPages }}</span>
          <button class="btn" v-on:click="page++" v-if="page < numPages" title="Next page">
            <icon :icon="['fad', 'angle-right']"/>
          </button>
          <button class="btn disabled" disabled v-else>
            <icon :icon="['fad', 'angle-right']"/>
          </button>
          <button class="btn" v-on:click="page = numPages" v-if="page < numPages" title="Last page">
            <icon :icon="['fad', 'angle-double-right']"/>
          </button>
          <button class="btn disabled" disabled v-else>
            <icon :icon="['fad', 'angle-double-right']"/>
          </button>
        </div>
      </div>
      <div class="row" v-if="isMobile()">
        <div class="col">
          <Comment :poster_id="poster.id" v-if="poster"></Comment>
        </div>
      </div>
      <div class="row" v-if="$route.name ==='poster'">
        <div class="col">
          <a target="_blank" :href="getPDFUrl('poster')">
            <icon :icon="['fad', 'file-download']"/>
            Download</a>
        </div>
      </div>
    </div>
    <loader v-else></loader>
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import Rating from "../components/Rating";
import ViewControlls from "./ViewControlls";
import axios from 'axios'
import Loader from '../components/Loader';
import Comment from "@/views/Comment";
import pdfvuer from 'pdfvuer'

export default {
  name: "ViewerPDF",
  components: {Comment, ViewControlls, Rating, Loader, pdf: pdfvuer},
  computed: {
    ...mapState({
      fullscreen: 'fullscreen'
    }),
    ...mapGetters({
      poster: 'poster'
    }),
  },
  data() {
    return {
      show: true,
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      rotate: 0,
      scale: 'page-width',
      pdfdata: undefined,
    }
  },
  methods: {
    ...mapActions({
      getPosterById: 'getPosterById',
    }),
    getClasses() {
      let code = 'col col-xl-7 offset-xl-2 col-12 border overflow-auto';
      if (this.$store.state.fullscreen === true) {
        code = 'col border overflow-auto';
      }
      return code;
    },
    async getPdf() {
      this.$store.commit('setPoster', {});
      this.getPosterById(this.$route.params.id).then((response) => {
        this.$store.commit('setPoster', response.data);
        let self = this;
        self.pdfdata = pdfvuer.createLoadingTask(this.getPDFUrl(this.$route.name));
        self.pdfdata.then(pdf => {
          console.log(pdf);
          self.numPages = pdf.numPages;
        });
      }).catch((error) => {
      })
    },
    getPDFUrl(target) {
      let src = '';
      if (!this.poster || !this.poster.content) {
        return src;
      }
      if (target === 'poster') {
        src = this.poster.content.poster;
      } else if (target === 'additional_paper') {
        src = this.poster.content.additional_paper;
      }
      return process.env.VUE_APP_PATH_S3URL + src;
    },
    getAudioUrl(src) {
      return process.env.VUE_APP_PATH_S3URL + src;
    },
    getBackUrl() {
      return '/view/' + this.$route.params.id;
    },
    toggleFullscreen() {
      this.$store.state.fullscreen = !this.$store.state.fullscreen;
    },
    showVideo(video) {
      this.$store.state.presentationSite = this.page;
      this.$router.push('/viewer/video/' + video);
    },
    keyPressed: function (event) {
      if ((event.which === 37 || event.which === 33) && this.page > 1) {
        this.page--;
      }
      if ((event.which === 39 || event.which === 34) && this.page < this.numPages) {
        this.page++;
      }
    },
    forceFileDownload(response) {
      this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'download/pdf', this.$route.params.id);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', process.env.VUE_APP_PATH_S3URL + this.$store.state.poster.content.poster);
      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios(src) {
      axios({
        method: 'get',
        url: this.getPDFUrl(src),
        responseType: 'arraybuffer'
      })
          .then(response => {
            this.forceFileDownload(response)
          })
          .catch(() => alert('error occured'))
    },
    error: function (err) {
    }
  },
  beforeRouteLeave(to, from, next) {
    this.page = 1;
    next();
  },
  mounted() {
    this.$store.state.fullscreen = true;
  },
  created() {
    this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'viewer/pdf', this.$route.params.id);
    window.addEventListener('keyup', this.keyPressed);
    this.getPdf();
    if (this.$store.state.presentationSite > 0) {
      this.page = this.$store.state.presentationSite;
    }
  }
}
</script>
<style src="pdfvuer/dist/pdfvuer.css"></style>
